/* 루미나 화면 층 신작 — 블랙 홈 게임사 그리드(components/common/ProviderGrid.jsx 가 그리던 .provider-item)를 시안 .pgrid > .gcard 로 그린다.
   게임사 코드·표시 이름(한글/영문)·캐릭터 경로(character_url 우선, 관리자 '제거'(character_hidden) 시 미렌더, 업로드 캐릭터는 webp 미생성)·
   로고(logo_url, logo_hidden 시 미렌더) 규칙은 ProviderGrid 와 같다. 클릭은 부모가 넘긴 onProviderClick(슬롯 = 게임 목록 창 / 카지노 = 로비 실행).
   WHY: SPEC §2·§3.2 — 값은 전부 유저 API 게임사 응답(접속 주소 배정 디자인 기준 이미지)에서 온다. 홈 전용 카드라 블랙 공용 ProviderGrid 는 손대지 않는다. */
import React, { memo } from 'react';
import { getProviderNames } from '../../utils/providerUtils';
import { resolveApiImageUrl } from '../../utils/logoUtils';
import { IconBtn, onEnterOrSpace, providerCodeOf, providerCharacterSources } from './homeShared';

const HomeProviderGrid = ({ providers, type, onProviderClick, vendorNames = {} }) => (
  <div className="pgrid">
    {providers.map((provider, index) => {
      // 내부 식별용 코드 (API 호출, 이미지 경로 등에 사용) — ProviderGrid 와 같은 우선순위(규칙은 homeShared 한 곳)
      const providerCode = providerCodeOf(provider);
      const englishName = provider.name || provider.provider_name || providerCode;
      const lowerProviderCode = String(providerCode).toLowerCase();
      const koreanName = provider.name_ko ||
        (vendorNames && vendorNames[lowerProviderCode]) ||
        getProviderNames(providerCode).korean;

      // 캐릭터 이미지: API 의 character_url 우선, 없으면 기본 경로. 관리자가 '제거'한 캐릭터(character_hidden)는 그리지 않는다.
      // 업로드 캐릭터(/uploads/*.png)는 동명 webp 가 없어 <source> 를 만들지 않는다(정적 기본 캐릭터만 webp).
      // 규칙은 히어로 게임 카드와 함께 쓰도록 homeShared.providerCharacterSources 한 곳에 있다(2026-09-28).
      const characterSources = providerCharacterSources(provider, type);
      const characterHidden = !characterSources;
      const characterImagePathPng = characterSources ? characterSources.png : null;
      const characterImagePathWebp = characterSources ? characterSources.webp : null;

      // [루미나] 게임 수 = 응답값(game_count). 없으면 칸을 비운다(지어내지 않음). 카지노는 로비 카드라 LIVE 표기(슬롯·카지노 페이지 카드와 동일)
      const gameCount = provider.game_count != null && provider.game_count !== '' && !isNaN(Number(provider.game_count))
        ? Number(provider.game_count).toLocaleString('ko-KR')
        : null;

      const activate = () => onProviderClick(provider);

      return (
        <article
          key={`provider-${providerCode}-${index}`}
          className="gcard group"
          role="button"
          tabIndex={0}
          aria-label={koreanName}
          onClick={activate}
          onKeyDown={onEnterOrSpace(activate)}
        >
          <div className="top">
            <span className="tag">{type === 'slot' ? '슬롯' : '카지노'}</span>
            {type === 'slot'
              ? (gameCount && <span className="cnt">{gameCount} 게임</span>)
              : <span className="cs-live">LIVE</span>}
            {/* 관리자 등록 로고(게임사 카드와 같은 출처) — 등록이 없거나 표시 금지(logo_hidden)면 그리지 않고(기본 대체 로고는 정보가 없다), 불러오기 실패면 숨긴다 */}
            {provider.logo_hidden !== true && provider.logo_url && (
              <img
                className="plogo"
                src={resolveApiImageUrl(provider.logo_url)}
                alt={englishName}
                loading="lazy"
                onError={(e) => { e.currentTarget.style.display = 'none'; }}
              />
            )}
          </div>
          <div className="im">
            {!characterHidden && (
              <picture>
                {characterImagePathWebp && <source srcSet={characterImagePathWebp} type="image/webp" />}
                <img
                  src={characterImagePathPng}
                  alt=""
                  loading="lazy"
                  draggable={false}
                  onError={(e) => { e.target.closest('picture').style.display = 'none'; }}
                />
              </picture>
            )}
          </div>
          <div className="bottom">
            <div className="nm">
              <h3>{koreanName}</h3>
              {koreanName !== englishName && <span className="en">{englishName}</span>}
            </div>
            <IconBtn />
          </div>
        </article>
      );
    })}
  </div>
);

export default memo(HomeProviderGrid);
